import {useEffect, useRef, useState} from "react";
import styles from './MVSlot.module.scss'
import Icon from "@/components/UI/Icon/Icon";
import {useCanRunAds} from "@/components/AdProvider/AdProvider";

const debounceMs = 150;
const DESKTOP_SIZES = [
  {width: 728, height: 90},
  {width: 468, height: 60},
  {width: 336, height: 280},
  {width: 300, height: 250},
  {width: 300, height: 200},
  {width: 320, height: 100},
  {width: 320, height: 50},
  {width: 300, height: 50},
  {width: 250, height: 250},
];
const MOBILE_SIZES = [
  {width: 320, height: 100},
  {width: 320, height: 50},
  {width: 300, height: 50},
];

const MVSlot = () => {

  const containerRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);
  const canRunAds = useCanRunAds();

  useEffect(() => {
    if (!containerRef.current) return
    setHeight(containerRef.current.clientHeight)
    setWidth(containerRef.current.clientWidth)
    let timeoutId: number | null = null;
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;

      const nextHeight = entry.contentRect.height;
      const nextWidth = entry.contentRect.width;

      // Clear previous timer and start a new one
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }

      timeoutId = window.setTimeout(() => {
        // Only update state if the height actually changed
        setHeight((prev) => (prev === nextHeight ? prev : nextHeight));
        setWidth((prev) => (prev === nextWidth ? prev : nextWidth));
      }, debounceMs);
    })

    observer.observe(containerRef.current);

    return () => {
      observer.disconnect();
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [canRunAds]);

  if (!canRunAds) return null;

  const isTooSmall = width < 250 || height < 50;

  const fitsDesktop = DESKTOP_SIZES.filter(size => width >= size.width && height >= size.height);
  const fitsMobile = MOBILE_SIZES.filter(size => width >= size.width && height >= size.height);

  const desktopSlotSizeString = fitsDesktop.map(size => `${size.width}x${size.height}`).join(',');
  const mobileSlotSizeString = fitsMobile.map(size => `${size.width}x${size.height}`).join(',');

  return (
    <div ref={containerRef} className={styles.container}>
      {!isTooSmall && (
        <>
          <a href="https://patreon.com/edhrec" className={styles.patreon} target="_blank" rel="noopener noreferrer">
            <Icon icon="patreon"/>Support EDHREC on Patreon to remove ads.
          </a>
          <div className="mv_slot_target_desktop" data-slot="content" style={{zIndex: 1}}
               data-hint-slot-sizes={desktopSlotSizeString}></div>
          <div className="mv_slot_target_mobile" data-slot="content" style={{zIndex: 1}}
               data-hint-slot-sizes={mobileSlotSizeString}></div>
        </>
      )}

    </div>
  );
}

export default MVSlot;